module.exports = __webpack_public_path__ + "img/dots_bronze.895b8b20.png";